import { createWebHistory, createRouter } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    redirect: "/Home", // Redirect to login for unauthenticated users
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../register.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../ForgotPassword.vue"),
  },
  //   {
  //   path: "/forgotpassword",
  //   name: "forgotpassword",
  //   component: () => import("../forgot.vue"),
  // },
  // component: () => import("../LoginPage.vue"),
  {
    path: "/Home",
    name: "Home",
    component: () => import("../view/HomePage/Home.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../view/Dashboard/Dashboard.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  // {
  //   path: "/TicketBooking",
  //   name: "TicketBooking",
  //   component: () => import("../view/TicketBooking/TicketBooking.vue"),
  // },
  {
    path: "/CategoryList",
    name: "CategoryList",
    component: () => import("../view/Category/CategoryList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
   {
    path: "/slotmanagement",
    name: "SlotManagement",
    component: () => import("../view/SlotManagment/SlotManagment.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/gameManagement/create",
    name: "GameManagement",
    component: () => import("../view/GameManagment/GameManagement.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/gameManagement/edit/:id",
    name: "GameManagementEdit",
    component: () => import("../view/GameManagment/GameManagement.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/gameList",
    name: "GameList",
    component: () => import("../view/GameManagment/GameList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/membershiplist",
    name: "MembershipList",
    component: () => import("../view/Membership/MembershipAdminList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/membership/create",
    name: "MembershipAdd",
    component: () => import("../view/Membership/MembershipAdminAdd.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/membership/edit/:id",
    name: "MembershipEdit",
    component: () => import("../view/Membership/MembershipAdminAdd.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/membership",
    name: "MembershipUser",
    component: () => import("../view/Membership/MembershipUser.vue"),
    meta: { requiresAuth: true, requiresUser: true },
  },
  {
    path: "/membership/payment/:id",
    name: "MembershipUserPayment",
    component: () => import("../view/Membership/MembershipUserPayment.vue"),
    meta: { requiresAuth: true, requiresUser: true },
  },
  {
    path: "/gamebooking",
    name: "GameBooking",
    component: () => import("../view/GameBooking/GameBooking.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/planbooking",
    name: "PlanBooking",
    component: () => import("../view/PlanBooking/PlanBooking.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/BookingHistory",
    name: "BookingHistory",
    component: () => import("../view/GameBooking/BookingHistory.vue"),
    meta: { requiresAuth: true, requiresUser: true },
  },
  {
    path: "/managemembership",
    name: "ManageMembershipList",
    component: () =>
      import("../view/ManageMembership/ManageMembershipList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/reportlist",
    name: "ReportList",
    component: () => import("../view/Report/ReportList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/membershipreport",
    name: "MembershipReport",
    component: () => import("../view/Report/MembershipReport.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/reward",
    name: "RewardList",
    component: () => import("../view/Reward/RewardList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/gallerylist",
    name: "GalleryList",
    component: () => import("../view/Gallery/GalleryList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/privacypolicy",
    name: "PrivacyPolicy",
    component: () => import("../view/Policy/PrivacyPolicy.vue"),
  },
  {
    path: "/termscondition",
    name: "TermsCondition",
    component: () => import("../view/Policy/TermsCondition.vue"),
  },
  {
    path: "/contactus",
    name: "ContactUs",
    component: () => import("../view/ContactUs/ContactUs.vue"),
  },
  {
    path: "/rules-regulations",
    name: "RulesandRegulations",
    component: () => import("../view/RulesRegulation/Rules.vue"),
  },
  {
    path: "/mybooking",
    name: "MyBooking",
    component: () => import("../view/MyBooking/MybookingList.vue"),
    meta: { requiresAuth: true, requiresUser: true }, // Added for user-specific access
  },
  {
    path: "/myplan",
    name: "MyPlan",
    component: () => import("../view/MyPlan/MyPlanList.vue"),
    meta: { requiresAuth: true, requiresUser: true }, // Added for user-specific access
  },
  {
    path: "/myaccount",
    name: "MyAccount",
    component: () => import("../view/MyAccount/MyAccountsDashboard.vue"),
    meta: { requiresAuth: true, requiresUser: true }, // Added for user-specific access
  },
  {
    path: "/userlist",
    name: "UserList",
    component: () => import("../view/User/UserList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admingamebooking",
    name: "AdminGameBookingList",
    component: () =>
      import("../view/AdminGameBooking/AdminGameBookingList.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admingamebooking/create",
    name: "AdminGameBookingAdd",
    component: () => import("../view/AdminGameBooking/AdminGameBookingAdd.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/notfound",
    name: "NotFound",
    component: () => import("../Notfound.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/notfound",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = store.state.userToken;
  const userRole = store.state.userRole;

  // Redirect unauthenticated users to login
  if (to.meta.requiresAuth && !token) {
    next("/login");
  }
  // Redirect authenticated users away from login
  else if (to.path === "/login" && token) {
    if (userRole === "admin") {
      next("/dashboard"); // Admins go to dashboard
    } else {
      next("/Home"); // Users go to Home
    }
  }
  // If admin tries to access /Home, redirect to /dashboard
  else if (to.path === "/Home" && userRole === "admin") {
    next("/dashboard");
  }
  // Prevent users from accessing admin routes
  else if (to.meta.requiresAdmin && userRole === "user") {
    next("/Home");
  }
  // Prevent admins from accessing user routes
  else if (to.meta.requiresUser && userRole === "admin") {
    next("/dashboard");
  }
  // Allow navigation for valid access
  else {
    next();
  }
});

export default router;
